export default __webpack_public_path__ + "static/media/coldy.d5f065db.png";